import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all assetLocations
export const getAssetLocations = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-locations`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-locations:", error.response?.data || error);
    throw error;
  }
};

// GET a single assetLocation
export const getAssetLocationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-locations/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-locations:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new assetLocation
export const createAssetLocation = async (assetLocationData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-locations`, assetLocationData);
    return response.data;
  } catch (error) {
    console.error("Error creating asset-locations:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing assetLocation
export const updateAssetLocation = async (id, assetLocationData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-locations/${id}`, assetLocationData);
    return response.data;
  } catch (error) {
    console.error("Error updating asset-locations:", error.response?.data || error);
    throw error;
  }
};

// DELETE a assetLocation
export const deleteAssetLocation = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-locations/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting asset-locations:", error.response?.data || error);
    throw error;
  }
};

// GET latest location per asset
export const getLastAssetLocation = async (assetIds = []) => {
  try {
    const ids = Array.isArray(assetIds) ? assetIds.filter(Boolean) : [];
    if (!ids.length) return [];
    const response = await axiosInstance.get(`${API_URL}/asset-locations/last/by-assets`, {
      params: { assetIds: ids.join(',') },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching latest asset-locations:", error.response?.data || error);
    throw error;
  }
};


// GET latest location for a single asset
export const getAssetLocationByAssetId = async (assetId) => {
  try {
    if (!assetId) return null;
    const response = await axiosInstance.get(`${API_URL}/asset-locations/last/by-asset`, {
      params: { assetId },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching latest asset-location by asset id:", error.response?.data || error);
    throw error;
  }
};
